import * as React from 'react';
import { memo } from 'react';

const SvgXCircle = (props) => (React.createElement("svg", Object.assign({ width: "1em", height: "1em", viewBox: "0 0 19 18", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M9.909 15.75a6.75 6.75 0 1 0 0-13.5 6.75 6.75 0 0 0 0 13.5Z", stroke: "currentColor", strokeMiterlimit: 10 }),
    React.createElement("path", { d: "m12.159 6.75-4.5 4.5M12.159 11.25l-4.5-4.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" })));
const Memo = memo(SvgXCircle);

export { Memo as default };
